var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChainesTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 0.25C6.60938 0.25 6.375 0.507812 6.375 0.8125V4.5625C6.375 4.89062 6.60938 5.125 6.9375 5.125H11.4375C11.7422 5.125 12 4.89062 12 4.5625V0.8125C12 0.507812 11.7422 0.25 11.4375 0.25H6.9375ZM5.0625 0.25H0.5625C0.234375 0.25 0 0.507812 0 0.8125V4.5625C0 4.89062 0.234375 5.125 0.5625 5.125H5.0625C5.36719 5.125 5.625 4.89062 5.625 4.5625V0.8125C5.625 0.507812 5.36719 0.25 5.0625 0.25ZM0 6.4375V10.1875C0 10.5156 0.234375 10.75 0.5625 10.75H5.0625C5.36719 10.75 5.625 10.5156 5.625 10.1875V6.4375C5.625 6.13281 5.36719 5.875 5.0625 5.875H0.5625C0.234375 5.875 0 6.13281 0 6.4375ZM6.9375 10.75H11.4375C11.7422 10.75 12 10.5156 12 10.1875V6.4375C12 6.13281 11.7422 5.875 11.4375 5.875H6.9375C6.60938 5.875 6.375 6.13281 6.375 6.4375V10.1875C6.375 10.5156 6.60938 10.75 6.9375 10.75Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainesTv);
export default __webpack_public_path__ + "static/media/chainesTv.fbfc5b24.svg";
export { ForwardRef as ReactComponent };